exports.default = {
  history_empty: '暫無影片歷史對話',
  history_load_more: '載入更多',
  cases_ui: {
    "audio": "音訊",
    "gallery_eyebrow": "靈感 · 創作過程",
    "gallery_title": "影片案例",
    "gallery_description": "從分鏡圖片到成片，看看一個創意如何在對話中完成。",
    "categories": "案例分類",
    "all_categories": "全部案例",
    "search": "搜尋影片案例",
    "search_submit": "搜尋",
    "sort": "案例排序",
    "recommended": "精選推薦",
    "latest": "最新發布",
    "popular": "熱門案例",
    "loading_cases": "正在載入影片案例",
    "loading_detail": "正在載入案例與創作過程…",
    "cases_failed": "暫時無法載入影片案例，請重試。",
    "detail_failed": "案例暫時無法查看，可能已下架或連結已失效。",
    "categories_failed": "分類暫時無法載入，仍可瀏覽全部案例。",
    "empty_cases": "影片案例正在準備中",
    "empty_cases_hint": "這裡將展示影片成品，以及從圖片分鏡到影片的完整創作過程。",
    "empty_search": "沒有找到符合的案例，試試其他關鍵字或分類。",
    "clear_filters": "清除篩選",
    "total": "{count} 個案例",
    "untitled": "未命名影片案例",
    "open_case": "查看案例：{title}",
    "view_process": "查看創作過程",
    "process_label": "對話中的創作",
    "detail_title": "影片創作案例",
    "read_only": "唯讀展示 · 不會執行歷史任務或產生生成費用",
    "conversation": "創作對話",
    "preview": "成品預覽",
    "outputs": "生成成品",
    "filter_media": "篩選成品類型",
    "all": "全部",
    "image": "圖片",
    "video": "影片",
    "reference": "參考素材",
    "user": "使用者",
    "assistant": "AI 助手",
    "prompt": "提示詞",
    "empty_conversation": "此案例未提供可公開的對話記錄。",
    "empty_media": "暫無可預覽的成品。",
    "empty_filter": "此類型暫無成品。",
    "select_media": "查看第 {index} 項{type}",
    "media_failed": "素材暫時無法播放或顯示，請重試。",
    "continue_chat": "繼續對話",
    "continuing": "正在準備會話…",
    "continue_unavailable": "此案例沒有可繼續的會話上下文，仍可查看成品。",
    "continue_failed": "暫時無法繼續對話，請重試。不會自動傳送訊息或生成影片。",
    "make_same": "做同款",
    "make_same_notice": "提示詞和目前模型支援的參數已填入，尚未傳送。來源參考素材未匯入；需要完整素材和上下文，請使用案例中的「繼續對話」。",
    "close": "關閉",
    "dismiss": "知道了",
    "retry": "重試",
    "share_failed": "分享內容暫時無法載入，請重試。"
  },
  execution_regenerate_forbidden: "影片執行這一輪不支援重新回答。可重新整理查看原任務，或重新報價並確認生成新影片。",
  retry_prepare_failed: "重新回答準備失敗，未發起新回答，請重試。",
  execution_loading: "正在準備影片生成任務…",
  task_loading: "正在讀取影片任務…",
  task_media_pending: "影片已生成，正在取得播放網址",
  execution_failed: "這支影片未能提交，請查看本次執行回覆中的說明。",
  execution_unconfirmed: "這支影片的執行狀態尚未確認，正在核實原任務，請勿重複生成。",
  execution_refresh_failed: "暫時無法更新影片狀態，已保留目前結果，可重新整理重試。",
  title_brand: 'PAITEAMS',
  title: 'AI 影片創作',
  back: '返回',
  entry_title: '選擇影片入口',
  entry_caption: '聚合入口',
  entry_default_desc: '統一調度影片生成能力',
  video_entry: '影片創作',
  model_title: '選擇影片智能體',
  video_model: '影片模型',
  model_default_desc: '適合鏡頭、動作與場景生成',
  active: '已啟用',
  config_title: '影片參數',
  config_caption: '跟隨智能體設定',
  seconds: '秒',
  advanced: '輸出選項',
  sound: '聲音',
  outputs: '個輸出',
  declared: '已宣告',
  pending: '待支援',
  pending_adapter: '目前執行適配器尚未啟用此選項',
  config_note: '目前基礎鏈路提交時使用時長、解析度和比例；聲音與 K 數待執行適配器接入後啟用。',
  skill_title: '影片技能與預設',
  optional: '可選',
  composer_kicker: 'VIDEO BRIEF',
  composer_title: '描述你想看到的畫面',
  ready: '已就緒',
  waiting: '等待設定',
  choose_model: '請選擇影片智能體',
  choose_config: '請先選擇影片智能體',
  reference: '參考圖片',
  reference_hint: '可選，幫助保持主體和風格一致',
  generate: '開始生成',
  send_message: '傳送給智能體',
  previous_quote_notice: '以下為歷史報價或任務，依卡片內的原始參數處理；傳送新訊息不會確認、取消或重新提交它。',
  creating: '正在進入智能體對話',
  no_entry: '暫無可用的影片入口',
  no_models: '暫無可用的影片智能體',
  conversation_failed: '無法建立影片會話，請稍後再試。',
  new_conversation: '影片生成會話',
  auth_notice: '登入後即可選擇影片智能體並開始創作。',
  login: '登入',
  load_failed: '影片智能體暫時無法載入，請稍後再試。',
  back_home: '返回首頁',
  agent: '影片智能體',
  choose_agent: '選擇影片智能體',
  no_entry_agents: '暫無可用的影片入口智能體',
  no_video_agents: '暫無可用的影片模型',
  loading: '載入影片設定中',
  load_failed: '影片設定載入失敗',
  retry: '重試',
  prompt_label: '描述你想生成的影片',
  prompt_placeholder: '例如：一段 8 秒的產品開箱短片，鏡頭平穩，光線自然。',
  reference_images: '參考圖片',
  add_reference: '新增參考圖',
  remove_reference: '移除參考圖',
  settings: '影片參數',
  duration: '時長',
  select_duration: '選擇影片生成時長',
  duration_range_hint: '時長需在 {min} - {max} 秒內',
  seconds_short: '秒',
  resolution: '解析度',
  aspect_ratio: '畫面比例',
  frame_adaptive_ratio: '自動比例',
  reference_all: '全能參考',
  first_last_frame: '首尾幀參考',
  audio: '聲音',
  generation_count: '生成數量',
  output_count: '輸出數量',
  enabled: '開啟',
  disabled: '關閉',
  adapter_unavailable: '目前執行適配器暫不支援此參數',
  skills: '影片技能',
  presets: '分類預設',
  cases: '案例',
  recent: '最近創作',
  empty_cases: '暫無案例',
  empty_recent: '暫無影片會話',
  start: '開始創作',
  continue_chat: '進入對話工作台',
  select_agent_first: '請先選擇影片智能體',
  prompt_required: '請先輸入影片描述',
  agent_unavailable: '目前影片智能體不可用，請重新整理設定',
  config_source: '參數來自目前智能體設定',
  model: '模型',
  default_config: '預設設定',
  video_agent: '影片智能體',
  skill_selected: '已選擇技能',
  preset_selected: '已填入預設',
  case_selected: '已填入案例',
  chat_handoff_failed: '無法開啟影片對話，請稍後再試',
  signed_in_required: '登入後才能開始影片創作',
  video_preview: '影片預覽',
  play: '播放',
  pause: '暫停',
  download: '下載',
  download_preparing: '準備下載...',
  download_failed: '下載連結取得失敗，點擊重試',
  download_unavailable: '目前影片暫不支援下載',
  download_expired_refresh: '下載連結已過期，請重新整理頁面後再試',
  download_ready_click: '下載連結已就緒，請再次點擊下載按鈕',
  task_title: '影片生成',
  task_generating: '影片正在生成',
  task_ready: '影片已生成',
  task_failed: '影片生成失敗',
  task_failed_detail: '請稍後重試或調整描述後重新生成。',
  task_status_pending: '等待處理',
  task_status_running: '正在生成',
  task_status_ready: '生成完成',
  task_status_failed: '生成失敗',
  task_status_cancelled: '已取消',
  task_status_unknown: "任務狀態未知",
  task_parameters: {
    type: "任務類型",
    reference: "參考生成",
    edit: "原片編輯",
    follow_source_duration: "跟隨原片時長",
    follow_source_duration_value: "跟隨原片時長（{seconds} 秒）",
    adaptive_ratio: "自動選擇比例",
    follow_source_ratio: "跟隨原片比例",
    follow_source_ratio_value: "跟隨原片比例（{ratio}）",
    source_video: "原片",
    source_dimensions: "原片 {width} × {height}"
  },
  batch: {
    decision_declined: "本次不生成，未預占點數。",
    progress: "已確認 {total} 個影片 · 完成 {completed} 個 · 失敗或取消 {failed} 個",
    title: "影片報價方案",
    member_count: "{count} 個獨立影片",
    status_collecting: "報價收集中",
    status_ready: "請選擇生成範圍",
    status_decided: "已提交決定",
    status_invalidated: "歷史報價",
    status_cancelled: "已取消",
    collecting_notice: "正在收集同一批次的報價。批次準備完成後才能選擇與確認。",
    selection_label: "選擇本次要生成的影片",
    untitled: "影片方案",
    hold: "本次預占",
    parameters: "生成規格",
    points: "{points} 點數",
    seconds: "{seconds} 秒",
    script_source: "腳本：{title} · 第 {revision} 版",
    prompt_source: "來源：直接描述",
    input_snapshot: "檢視生成內容",
    input_unavailable: "生成內容暫不可用",
    associations: "檢視來源與任務關聯",
    quote_id: "報價 ID",
    batch_id: "批次 ID",
    script_id: "腳本 ID",
    decision_id: "決定 ID",
    dispatch_id: "提交 ID",
    task_id: "任務 ID",
    select_all: "全選",
    clear_selection: "取消勾選",
    selected_count: "已選 {count} 項",
    total_hold: "合計預占",
    selected_total: "已選 {count} 個影片 · 合計預占 {points} 點數",
    balance: "團隊可用點數：{points}",
    balance_unknown: "待核驗",
    insufficient_points: "所選預占點數超過團隊可用餘額。請減少選擇或補充點數；最終以伺服器校驗為準。",
    decision_notice: "確認後預占所選影片的點數，未選影片本次不生成。",
    reject_all: "本次不生成",
    confirm_selected: "確認生成",
    retry_same_decision: "重試",
    settlement_not_ready: "此報價暫時無法確認，本次未預占積分。請重新取得報價後再確認。",
    verify_failed: "報價載入失敗，請重新整理後重試。",
    scope_changed: "目前帳戶、團隊或會話無法存取此批次。",
    quote_changed: "報價版本、價格或成員已變更，請重新整理並檢查選擇。",
    action_failed: "操作未完成，請重新整理後重試。",
    recovery_unavailable: "無法儲存操作記錄，請允許瀏覽器儲存後重新整理重試。",
    decision_verify_failed: "狀態更新失敗，請重新整理後重試。",
    sync_pending: "狀態同步中",
    sync_conflict: "同步衝突，待核驗",
    confirmed_notice: "已確認，等待 AI 按本次報價繼續執行。",
    quote_confirmation_required: "待確認",
    quote_confirmed: "已確認",
    quote_consumed: "已使用",
    quote_rejected: "未通過 · 本次不生成",
    quote_invalidated: "已失效",
    quote_cancelled: "已取消",
    quote_unpriced: "暫無法報價",
    decision_saved: "已確認。",
    decision_committed: "已確認，等待生成。",
    decision_waiting_sync: "確認已儲存，正在同步；同步完成後由 AI 繼續執行。",
    decision_pending_ai: "已確認，等待 AI 執行。",
    decision_running_ai: "AI 正在處理已確認方案。",
    decision_retry_wait: "等待恢復原 AI 執行意圖。",
    decision_cancelled: "本次操作已取消。",
    decision_expired: "等待已結束，請重新整理查看。",
    decision_needs_attention: "生成狀態待確認，請重新整理查看。",
    reason_user_declined: "本次決定未選擇此方案，不生成影片，也不產生任務費用。",
    reason_quote_not_latest_round: "新的普通訊息已關閉這輪待確認報價，請讓 AI 重新報價。",
    reason_superseded: "此報價輪次已成為歷史。",
    reason_target_replaced: "該目標已被新報價取代。",
    reason_script_revision_changed: "腳本已有新版本，需要重新報價。",
    reason_pricing_changed: "價格規則已變更，需要重新報價。",
    reason_unavailable: "此方案需要重新整理正式狀態或重新報價。",
    task_unknown_notice: "原任務的提交狀態未知，繼續查詢原任務；不視為失敗、退款或新的生成授權。"
  },
  quote: {
    legacy_read_only: "舊版報價僅供查閱與恢復原任務。需要生成新影片時，請在聊天中重新報價。",
    estimate_summary: '預計 {points} 積分，按實際結算',
    estimate_consent: '確認即同意按實際費用結算：先預占預計積分；實際費用低於預計時自動退差，高於預計時自動補扣差額，團隊可用積分可能變為負數。確認時預計積分超過團隊可用積分，伺服器會阻止提交。',
    actual_base: '實際基礎費用（不含人工調整）',
    provisional_deducted: '預計暫扣（目前淨額）',
    net_deducted: '目前淨扣費',
    net_credit: '目前淨返還',
    estimate_difference: '實際費用與預計差額',
    charged_total: '累計扣費',
    refunded_total: '累計退款',
    supplemental_total: '累計補扣',
    adjustment: '人工調整（正為補扣，負為退款）',
    settlement_source: '結算依據',
    source_unavailable: '等待結算依據',
    source_provider_cost: '已核驗供應商費用',
    source_provider_usage: '已核驗供應商用量',
    source_verified_spec: '已核驗成功輸出規格',
    source_estimate: '預計費用（非實際用量）',
    billing_status_provisional: '計費：預計暫扣',
    billing_provisional: '已按預計 {points} 積分暫扣，目前預占 {held} 積分。實際費用尚未知；可信費用到達後會自動退差或補扣，人工調整會保留。自動重新整理有次數限制，之後仍可手動重新整理或回到頁面核驗。',
    billing_settled_v2: '實際基礎費用已核驗為 {points} 積分；目前淨扣費或淨返還、人工調整及累計退款見上方。原始預占已關閉，釋放 {released} 積分，目前預占 {held} 積分。釋放預占不是累計退款，也不一定增加可用餘額；過期或已停用額度不會恢復。',
    billing_calculated_v2: '待核驗基礎費用：{points} 積分，尚不是最終實際費用；已扣或已退金額以上方淨額為準。',
    billing_reason_estimate_fallback: '實際費用尚未到達，目前按預計暫扣；收到可信實際費用後自動結算差額，不把預計當作實際用量。',
    billing_reason_waiting_output: '生成成功通知已核驗，正在等待任務影片儲存完成；目前尚未扣費，預占繼續保留，伺服器會繼續核驗。',
    dispatch_pending_v2: '確認後先預占預計 {points} 積分，再由伺服器提交一個影片任務；預占不是扣費，後續按實際費用自動結算。',
    reservation_pending_v2: '確認後先預占預計 {points} 積分，而非扣費。生成提交尚未開放；後續結算以已確認的實際費用規則為準。',
    confirm_generate_v2: '確認預計 {points} 積分並生成',
    confirm_reserve_v2: '確認並預占預計 {points} 積分',
    insufficient_points_v2: '預計積分超過團隊可用積分，伺服器已阻止確認提交，未扣費。不會自動重試，請先重新整理報價狀態。',
    actual_deducted: "實際已扣積分",
    committed: "已確認扣除積分",
    settled_at: "結算時間",
    billing_status_not_started: "計費：未開始",
    billing_status_reserved: "計費：已預占",
    billing_status_awaiting_usage: "計費：等待用量",
    billing_status_settled: "計費：已結算",
    billing_status_released: "計費：提交前已釋放",
    billing_status_manual_review: "計費：待人工複核",
    billing_status_unpriced: "計費：暫無法定價",
    billing_status_unavailable: "計費狀態待核驗",
    billing_awaiting_usage: "正在等待可信用量以完成結算，目前仍預占 {held} 積分。影片就緒不代表計費已結算，仍可重新整理核驗。",
    billing_settled: "已核驗結算：實際扣除 {points} 積分，釋放預占 {released} 積分，目前預占 {held} 積分。釋放不一定增加團隊可用餘額，過期或已停用額度不會恢復。任務進度與結算狀態相互獨立。",
    billing_manual_review: "計費需要人工複核，目前保留預占 {held} 積分，尚未扣費。不能視為已退款，請勿重複提交。自動計費重新整理已暫停，仍可手動重新整理。",
    billing_unpriced: "實際用量暫無法安全定價，目前保留預占 {held} 積分，尚未扣費。未知用量不代表免費生成或已退款，仍可手動重新整理。",
    billing_calculated: "待複核試算積分：{points}。這不是已扣金額，也不代表授權超出最高額度扣費。",
    billing_reason_usage_missing: "缺少可信用量，不能按零用量處理，也不能視為預占已退回。",
    billing_reason_authorization_exceeded: "試算用量超過授權上限，需要複核；不推定額外扣費或退款。",
    billing_reason_settlement_policy_unconfigured: "凍結的計費策略不允許自動結算，需要複核。",
    billing_reason_failure_requires_review: "任務結果需要計費複核；生成失敗本身不會釋放預占。",
    billing_reason_estimated_usage: "估算用量不能用於最終結算，需要可信用量或人工複核。",
    billing_reason_usage_source_untrusted: "用量尚未通過結算核驗，預占繼續保留。",
    billing_reason_usage_conflict: "用量資訊存在衝突，需複核後才能結算。",
    billing_reason_currency_mismatch: "計費資訊與凍結報價不一致，需要複核。",
    billing_reason_manual_review: "計費需要人工複核，不能推定自動退款。",
    billing_reason_unpriced: "計費暫無法安全定價，不代表免費生成。",
    billing_reason_unavailable: "計費仍需核驗，請以上方已核驗金額為準，不推定扣費或退款。",
    billing_reason_multiple_final_usage: "存在多個最終用量記錄，需複核後才能結算。",
    billing_reason_usage_payload_conflict: "用量記錄存在衝突，需複核後才能結算。",
    billing_reason_retries_exhausted: "自動計費核驗未能完成，需要人工複核。",
    billing_reason_invariant_violation: "暫無法核驗計費一致性，不推定扣費或退款。",
    billing_reason_invalid_pricing: "凍結的計價規則暫無法對本次用量安全定價。",
    reason_dispatch_expired: "提交授權已過期，伺服器已在提交前取消任務並釋放預占；如需生成，請重新取得報價並確認。",
    confirm_generate: "確認預占並提交生成",
    dispatch_pending: "確認後將預占最高 {points} 積分，再由伺服器排隊提交單個影片生成任務；預占不是扣費。",
    dispatch_held: "目前仍預占 {points} 積分。提交狀態或任務完成均不代表已扣費；僅以伺服器核驗結果為準，不因報價到期自動釋放。",
    dispatch_status_queued: "已排隊",
    dispatch_status_submitting: "正在提交",
    dispatch_status_accepted: "已受理",
    dispatch_status_unknown: "提交狀態未知",
    dispatch_status_rejected: "提交遭拒",
    dispatch_status_cancelled: "提交已取消",
    dispatch_queued: "已預占並排隊，尚未開始提交時可取消；若工作程序已開始提交，則不能取消。",
    dispatch_submitting: "伺服器正在提交生成任務，目前不可取消。積分繼續預占。",
    dispatch_accepted: "生成請求已受理，不代表影片已完成或已扣費。請以下方已核驗任務的進度與結果為準。",
    dispatch_unknown: "無法確定提交結果，目前不可取消。積分繼續預占；請重新整理伺服器狀態，不要重複提交。",
    dispatch_rejected: "伺服器已確認提交遭拒，此報價已失效；預占已釋放，釋放結果以下方積分記錄為準。",
    dispatch_cancelled: "伺服器已確認在提交前取消並釋放預占；不會恢復已過期的積分。",
    reason_dispatch_rejected: "提交遭拒，原報價已失效。如需重新生成，請取得新報價並再次明確確認。",
    task_verify_failed: "暫時無法核驗目前報價的任務歸屬或進度，未顯示未核驗結果。請重新整理狀態；預占不會因此釋放。",
    active_quote_retained: "目前報價仍有預占、生成任務或待核驗操作結果，已保留原始快照。修改輸入不會取消它，也不會再次提交生成。",
    dispatch_state_unknown: '暫時無法安全釋放預占，尚未核驗到取消或釋放成功。保留上次核驗的預占資訊，請重新整理報價狀態；不會自動重試。',
    reason_reservation_unavailable: '預占記錄無法使用，此報價已失效，請重新取得並核對報價。',
    confirm_reserve: '確認並預占最高 {points} 積分',
    cancel_release: '取消並釋放 {points} 積分',
    held: '目前預占（未扣費）',
    released: '已釋放預占積分',
    reservation_id: '預占編號',
    reservation_pending: '確認後將預占最高授權的 {points} 積分，預占並非扣費。影片生成仍被阻止，不會自動提交。',
    reservation_held: '目前預占 {points} 積分，尚未扣費。影片生成仍被阻止，尚未開始。',
    reservation_released: '已釋放預占 {points} 積分，目前預占 {held} 積分。實際可用積分以團隊餘額為準，過期或已停用額度不會恢復；未扣費，也未開始生成。',
    reservation_none: '此報價未預占或扣除積分，也不會啟動影片生成。',
    expiry_release_pending: '本機顯示報價已到期，但伺服器上次核驗仍有預占。請重新整理狀態或取消報價以核驗釋放，不能視為已釋放。',
    insufficient_points: '可用積分不足，無法預占最高授權積分。本次確認未成功，未扣費；不會自動重試，請先重新整理報價狀態。',
    refresh_status: '重新整理報價狀態',
    reason_billing_policy_changed: '預占策略已變更，此報價已失效，請重新取得並核對報價。',
    title: '影片報價確認',
    create: '取得影片報價',
    creating: '正在為目前輸入準備報價',
    verifying: '正在核驗報價歸屬與最新狀態',
    confirm: '確認此報價',
    cancel: '取消報價',
    estimated: '預計積分',
    maximum: '最高授權積分',
    points: '{points} 積分',
    unavailable: '暫無',
    model_unavailable: '模型暫不可用',
    status_confirmation_required: '待確認',
    status_confirmed: '已確認，待提交',
    status_cancelled: '已取消',
    status_invalidated: '已失效',
    status_expired: '已過期',
    status_unpriced: '暫無法報價',
    no_execution: '目前僅記錄報價確認，未預占或扣除積分，也不會啟動影片生成。',
    single_output_notice: '目前報價僅支援單個影片輸出，不支援音訊開關。',
    confirmed_pending: '確認已記錄，待提交。影片生成尚未開始。',
    page_snapshot: '此報價對應卡片內儲存的輸入，與上方新訊息無關；新的影片工具請求需要另行報價確認。',
    skill_snapshot: '技能可能改寫提示詞。此報價僅對應下方提示詞快照，不代表 AI 最終請求報價。',
    quote_changed: '報價已變更，請核對最新參數與積分後再次確認。',
    inputs_changed: '參數或參考素材已變更，此報價不能繼續確認。',
    scope_changed: '帳號或團隊已變更，此報價在目前對話中不可用。',
    create_failed: '暫時無法取得確認報價，請使用目前輸入重試。',
    tool_unavailable: '影片報價暫不可用，未記錄確認，也未開始生成。',
    verify_failed: '無法核驗此報價，核驗成功前不可確認。',
    action_failed: '無法核驗操作結果，請重新整理伺服器狀態後再試。',
    prompt_required: '請輸入非空提示詞以取得報價。',
    prompt: '提示詞快照',
    reference_mode: '參考模式',
    references: '參考素材',
    no_references: '無',
    breakdown: '報價明細',
    item: '項目 / 單位',
    quantity: '數量',
    billable_quantity: '計費數量',
    expires: '有效期限',
    rule_version: '計價規則版本',
    confirmed_at: '確認時間',
    reason_context_changed: '模型、輸入或參考素材已變更，請重新取得報價。',
    reason_pricing_changed: '計價規則已變更，請重新取得報價。',
    reason_superseded: '此報價已被新報價取代，請核對最新報價後確認。',
    reason_quote_expired: '報價已過期，請重新取得報價。',
    reason_unavailable: '此報價目前不可確認。'
  },
  constraints: {
    "error_dialog_title": "素材不符合目前模型要求",
    "error_acknowledge": "知道了",
    "error_reference": "素材 {index}：{name}",
    "details": {
      "unsupported_file": "不支援此媒體類型或格式。",
      "frames_images": "首尾幀只能使用圖片。",
      "type_count": "目前模型最多允許 {max} 項此類素材。",
      "format": "不支援格式 {actual}，允許：{allowed}。",
      "empty_file": "檔案為空。",
      "size": "大小 {actual} 位元組超過 {max} 位元組上限。",
      "size_exclusive": "大小必須小於 {max} 位元組，目前 {actual} 位元組。",
      "minimum": "{field}為 {actual}，最小要求 {min}。",
      "maximum": "{field}為 {actual}，最大允許 {max}。",
      "codec": "不支援{field} {actual}，允許：{allowed}。"
    },
    "model_rules": "目前選擇上限為 {max} 項；各類型數量及媒體要求分別驗證。50 僅為系統安全上限，不是模型官方聯合總上限。",
    "checking": "正在讀取本機檔案中繼資料…",
    "unnamed": "未命名檔案",
    "total_count": "已選 {actual} 項參考素材，目前上限為 {max} 項。請主動移除素材或切換模型，既有選擇已保留。",
    "mode": "目前模型不支援「{mode}」，既有參考素材已保留。",
    "unsupported_file": "第 {index} 項「{name}」：不支援此媒體類型或格式。",
    "frames_images": "第 {index} 項「{name}」：首尾幀只能使用圖片。",
    "type_count": "第 {index} 項（{type} {typeIndex}）「{name}」：目前模型最多允許 {max} 項此類素材。",
    "format": "第 {index} 項（{type} {typeIndex}）「{name}」：不支援格式 {actual}，允許：{allowed}。",
    "empty_file": "第 {index} 項（{type} {typeIndex}）「{name}」：檔案為空。",
    "size": "第 {index} 項（{type} {typeIndex}）「{name}」：大小 {actual} 位元組超過 {max} 位元組上限。",
    "size_exclusive": "第 {index} 項（{type} {typeIndex}）「{name}」：大小必須小於 {max} 位元組，目前 {actual} 位元組。",
    "minimum": "第 {index} 項（{type} {typeIndex}）「{name}」：{field}為 {actual}，最小要求 {min}。",
    "maximum": "第 {index} 項（{type} {typeIndex}）「{name}」：{field}為 {actual}，最大允許 {max}。",
    "codec": "第 {index} 項（{type} {typeIndex}）「{name}」：不支援{field} {actual}，允許：{allowed}。",
    "total_duration": "所選{type}總時長為 {actual} 毫秒，最大允許 {max} 毫秒。",
    "frames_first_required": "請先選擇首幀，再選擇尾幀。",
    "frames_ratio_mismatch": "首幀為 {firstWidth}×{firstHeight}，尾幀為 {lastWidth}×{lastHeight}，寬高比必須相同（像素尺寸可不同）。請更換其中一幀。",
    "audio_only": "目前模型不支援僅音訊參考。請新增圖片或影片、移除音訊，或切換模型。",
    "pending": "第 {index} 項（{type} {typeIndex}）「{name}」：待伺服器核驗中繼資料。瀏覽器無法讀取或未知資料不代表通過；播放失敗不代表生成失敗。",
    "fields": {
      "width": "寬度（像素）",
      "height": "高度（像素）",
      "ratio": "寬高比",
      "pixels": "像素總數",
      "duration_ms": "時長（毫秒）",
      "frame_rate": "幀率（fps）",
      "video_codec": "影片編碼",
      "audio_codec": "音訊編碼"
    }
  },
  media: {
    reference_mode: '參考模式',
    scope_changed: '使用者或團隊已切換，請重新開啟影片對話後繼續。',
    "picker_title": "選擇影片參考素材",
    "selected": "已選素材",
    "upload": "上傳檔案",
    "limits": "最多 {max} 項，每項不超過 50MiB。支援 PNG/JPEG/WebP、MP4/WebM/MOV、MP3/WAV/M4A/OGG。",
    "capability_notice": "參考類型能否用於生成取決於模型與供應商；不支援時會明確提示。",
    "image": "圖片",
    "video": "影片",
    "audio": "音訊",
    "all": "全部",
    "asset_library": "素材庫",
    "filter": "篩選素材類型",
    "empty": "暫無此類型素材，可上傳或載入更多。",
    "retry": "重試",
    "load_more": "載入更多",
    "cancel": "取消",
    "confirm": "確認選擇",
    "remove_named": "移除 {name}",
    "preview_named": "預覽 {name}",
    "unsupported_file": "不支援此檔案格式，請選擇提示中列出的圖片、影片或音訊格式。",
    "file_too_large": "檔案不能為空，且每項不能超過 50MiB。",
    "too_many": "最多選擇 {max} 項參考素材。",
    "upload_failed": "{name} 上傳失敗，請重試；成功的檔案已保留。",
    "first_frame": "首幀",
    "last_frame": "尾幀",
    "replace": "替換",
    "add": "新增參考",
     "reference_content": "參考內容",
    "reference_count": "{count} 項參考",
     "expand": "展開參考內容",
     "collapse": "收起參考內容",
     "clear_all": "清空全部素材",
     "reference_all_prompt_placeholder": "上傳參考素材，輸入文字，自由組合圖、文、音、影片多元素。",
     "first_last_frame_prompt_placeholder": "輸入文字，描述你想創作的畫面內容、運動方式等。例如：一個3D形象的小男孩，在公園溜滑板。",
    "preview": "素材預覽",
    "preview_unavailable": "預覽無法使用",
    "preview_failed": "素材預覽暫不可用，請重試。",
    "loading": "正在載入預覽…"
}
}
